<template>
  <div class="upload">
    <el-upload class="uploadvideo" action="" :accept="allowFileType" :on-change="handleChange" :file-list="fileList"
      :auto-upload="false" :show-file-list="false">
      <el-button v-show="btnshow" slot="trigger" size="mini">上传本地视频</el-button>
      <el-button :class="innerTable ? '' : 'bgc-bv'" size="mini" :type="innerTable ? 'text' : ''"
        v-if="showVideoId.kpointVideoId" :disabled="!btnshow2" @click.stop="() => showVideo(showVideoId)">预览</el-button>
      <div slot="tip" class="el-upload__tip" v-if="showProgress">
        <el-progress :color="customColor" :text-inside="true" :stroke-width="26" :percentage="authProgress"
          style="width: 350px"></el-progress>
      </div>
    </el-upload>
    <el-dialog v-if="dialogVisible1" :title="videotitle" :modal="false" :visible.sync="dialogVisible1" width="60%"
      :before-close="handleClose">
      <player_2 :videoId="videoId" :videoTime="videoTime" :kpointSource="kpointSource" v-if="videoType" />
      <player_1 :watermark="watermark" :videoId="videoId" :videoTime="videoTime" :kpointSource="kpointSource" v-else />
    </el-dialog>
  </div>
</template>
<script>
import player_1 from "@/components/player";
import player_2 from "@/components/playerTrysee";
import { Loading } from 'element-ui';

export default {
  props: {
    showVideoId: Object,
    btnshow: Boolean,
    btnshow2: Boolean,
    watermark: {//是否开启水印
      type: Boolean,
      default: false
    },
    innerTable: {//是否在列表中
      type: Boolean,
      default: false
    },
  },
  components: {
    player_1,
    player_2
  },
  data() {
    return {
      //上传对象
      fileList: [],
      allowFileType: ".mp4,.MP4",
      //组件对象
      uploader: null,
      // 是否正在上传
      uploading: false,
      authProgress: 0,
      uploadState: "1",
      statusText: "",
      customColor: "#5C6BE8",
      showProgress: false,
      videoId: "", // 視頻id
      videoType: null, // true-可以看；false-试看
      dialogVisible1: false,
      videotitle: "",
      videoTime: "",
    };
  },
  created() {

  },
  methods: {
    // 特殊字符校验规则
    checkReg(val, regName) {
      let reg = {
        userName: /^[a-zA-Z0-9_]{2,16}$/,
        password: /^[A-Za-z0-9]+$/,
        fullName: /^[\u4e00-\u9fa5]+$/,
        caseAndNumber: /^[A-Za-z0-9]+$/,
        code: /^[A-Za-z0-9_-]+$/,
        phone: /^((0\d{2,3}-\d{7,8})|(0\d{9,11})|(1\d{10})|(\d{7,8}))$/,
        mobile: /^1\d{10}$/,
        fileName: new RegExp('[\\\\/:*?"<>|]'),
        eMall: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      };
      return reg[regName].test(val);
    },
    // 文件基本信息校验
    beforeUpload(file) {
      let that = this;
      //文件名不能超长
      let fileName = file.name;
      if (fileName.length > 100) {
        that.$message.warning({
          message: "资源文件名称不能大于100个字符！",
          duration: 1000
        });
        return false;
      }
      // 不能还有特殊字符
      if (that.checkReg(fileName, "fileName")) {
        that.$message.warning({
          message: "资源文件[" + fileName + "]名称不能包含特殊字符！",
          duration: 1000
        });
        return false;
      }
      //校验文件类型，是否允许上传
      let fileType = file.name.split(".");
      if (!that.allowFileType.includes(fileType[fileType.length - 1])) {
        that.$message.warning({
          message: "只能上传.MP4格式的文件！",
          duration: 1000
        });
        return false;
      }
      return true;
    },
    // 文件列表改变回调
    handleChange(file, fileList) {
      //校验文件
      if (this.beforeUpload(file)) {
        //添加视频
        if (this.uploader) {
          this.uploader.stopUpload();
          this.authProgress = 0;
          this.statusText = "";
        }
        this.uploader = this.createUploaderHw();
        this.uploader.addFile(file);
        this.uploadState = "1";
        //删除之前的文件。
        this.fileList = fileList.slice(-1);
        //修改为验证文件通过后直接开始上传的模式
        this.showProgress = true;
        this.authUpload();
      } else {
        this.fileList = [];
      }
    },
    // 开始上传
    authUpload() {
      // 然后调用 startUpload 方法, 开始上传
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.uploadState = "2";
      } else {
        this.$message("您还未选择上传视频！");
      }
    },
    // 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
    sendVideoId(videoId) {
      this.$emit("childFn", videoId);
    },
    // 打开预览视频 - 弹框
    showVideo(data) {
      let _this = this;
      //单元测试打开是题库
      if (data.kpointVideoId) {
        _this
          .$post("/biz/courseware/auth", { videoId: data.kpointVideoId })
          .then(result => {
            _this.videoId = data.kpointVideoId;
            _this.videoType = result.data.trySee;
            _this.videoTime = result.data.duration;
            _this.videotitle = data.kpointName;
            _this.kpointSource = data.kpointSource;
            _this.dialogVisible1 = true;
          })
      }
    },
    // 关闭预览视频 - 弹框
    handleClose() {
      this.dialogVisible1 = false;
    },
    // 创建华为上传对象
    createUploaderHw() {
      let that = this;
      return {
        fileList: [],
        loading: null,
        stopUploadStatus: false,
        fileContentType: "video/mp4",
        // 循环上传分段数据
        forData: {
          // 文件分段计数
          partNumber: 1,
          // 文件读取位置
          position: 0,
          // 用于将文件对象分割成多个部分
          blobSlice: File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
          // 大小
          bufferSize: 1024 * 1024,
        },
        addFile(file) {
          this.fileList.push(file)
        },
        stopUpload() {
          this.onUploadCanceled()
          this.stopUploadStatus = true;
          if (this.loading) {
            this.loading.close();
            this.loading = null;
          }
        },
        startUpload() {
          this.stopUploadStatus = false;
          this.fileList.forEach(async file => {
            if (this.stopUploadStatus) {
              return;
            }
            let fileName = file.name;
            let createAssetByFileUpReq = {
              fileName: fileName,
              title: fileName,
              videoName: fileName,
              videoType: 'MP4'
            }
            this.loading = Loading.service({
              fullscreen: true,
              lock: true,
              text: "上传中，请稍后...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            try {
              // 获取 - 点播媒资数据
              let res = await that.$post("/sys/hw/vod/createAssetByFileUp", createAssetByFileUpReq, 3000, false);
              await this.getInitAuth(res.data.target.bucket, res.data.target.object, res.data.asset_id, file);
            } catch (e) {
              console.log(e)
              this.onUploadFailed(e.message)
              that.$message.error("上传失败");
              this.loading.close();
              this.loading = null;
            }
          })
        },
        // 获取[初始化上传任务]授权，获得授权的url
        async getInitAuth(bucket, object, asset_id, file) {
          let initPartUploadAuthorityReq = {
            bucket: bucket,
            fileContentType: this.fileContentType,
            object: object,
          };
          let res = await that.$post("/sys/hw/vod/initPartUploadAuthority", initPartUploadAuthorityReq, 3000, false);
          this.initPartUpload(res.data, bucket, object, asset_id, file);
        },
        initPartUpload(sign_url, bucket, object, asset_id, file) {
          let resp = this.sendRequest("POST", sign_url, null, { "Content-Type": "video/mp4" });
          let domParser = new DOMParser();
          let dom = domParser.parseFromString(resp, "text/xml");
          let uploadId = dom.getElementsByTagName("UploadId")[0].firstChild.nodeValue;
          this.readAndUpload(bucket, object, asset_id, uploadId, file)
        },
        // 循环上传分段
        readAndUpload(bucket, object, asset_id, uploadId, file) {
          if (this.stopUploadStatus) {
            return;
          }
          let _this = this;
          let fileReader = new FileReader();
          fileReader.onload = async function (e) {
            // 先文件分段md5
            const md5 = that.$md5(e.target.result);
            // md5转字节数组
            let bmd5 = that.$Str2Bytes(md5);
            // base64 encode md5字节数组
            let content_md5 = that.$base64js.fromByteArray(bmd5);
            // 5.获取分段上传授权
            let sign_url = await _this.getPartUploadAuthority(content_md5, bucket, object, asset_id, uploadId);
            // 6.上传分段
            _this.uploadPartFile(content_md5, e.target.result, sign_url);
            _this.forData.partNumber++;
            // 判断是否读完，未读完继续上传
            if (_this.forData.position + _this.forData.bufferSize < file.size) {
              _this.forData.position += _this.forData.bufferSize;
              _this.readAndUpload(bucket, object, asset_id, uploadId, file);
            } else {
              _this.forData.position = file.size;
              // 全部上传完成后执行后续步骤
              await _this.afterUpload(bucket, object, asset_id, uploadId, file);
            }
            _this.onUploadProgress(_this.forData.position / file.size);
          }
          let blob = this.forData.blobSlice.call(file.raw, this.forData.position, this.forData.position + this.forData.bufferSize);
          fileReader.readAsArrayBuffer(blob);
        },
        // 上传分段
        uploadPartFile(contentMd5, content, sign_url) {
          let headers = {
            "Content-Type": "application/octet-stream",
            "Content-MD5": contentMd5
          }
          let resp = this.sendRequest("PUT", sign_url, content, headers);
        },
        sendRequest(method, url, data, headers) {
          var xhr = new XMLHttpRequest();
          xhr.open(method, url, false);
          for (let i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }
          xhr.send(data);
          return xhr.responseText;
        },
        async getPartUploadAuthority(content_md5, bucket, object, asset_id, uploadId) {
          let res = await that.$post("/sys/hw/vod/getPartUploadAuthority", {
            bucket: bucket,
            contentMd5: content_md5,
            fileContentType: this.fileContentType,
            object: object,
            partNumber: this.forData.partNumber,
            uploadId: uploadId
          }, 3000, false)
          return res.data;
        },
        async afterUpload(bucket, object, asset_id, uploadId, file) {
          // 8.获取列举已上传段授权、获取已上传段、获取合并段授权、合并段、确认上传五合一
          let assetId = await this.mergeUploadedPartAndConfirmUpload(bucket, object, asset_id, uploadId, file);
          this.loading.close();
          this.loading = null;
          this.onUploadSucceed(assetId);
          this.onUploadEnd();
        },
        async mergeUploadedPartAndConfirmUpload(bucket, object, asset_id, uploadId, file) {
          let res = await that.$post("/sys/hw/vod/mergeUploadedPartAndConfirmUpload", {
            bucket: bucket,
            object: object,
            uploadId: uploadId,
            assetId: asset_id
          }, 3000, false)
          return res.data;
        },
        //文件上传成功
        onUploadSucceed: function (videoId) {
          that.sendVideoId(videoId);
          that.statusText = "文件上传成功!";
        },
        // 文件上传失败
        onUploadFailed: function (message) {
          console.log(message);
          that.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: function () {
          that.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (progress) {
          that.authProgress = Math.ceil(progress * 100);
          that.statusText = "文件上传中...";
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // TODO
        },
        // 全部文件上传结束
        onUploadEnd: function () {
          that.statusText = "文件上传完毕";
        }
      }
    }
  }
};
</script>
<style lang="less">
.upload {
  .uploadvideo {
    display: flex;

    .el-upload {
      height: auto !important;
      border: none;
    }
  }

  .el-button {
    height: auto !important;
  }
}
</style>
